var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.plugin.installHistory)?_c('div',[_c('ClientOnly',[_c('div',[_c('apex-chart',{attrs:{"type":"area","height":"40","options":_vm.chartOptions,"series":_vm.series}}),_vm._v(" "),(_vm.chartMounted)?_c('div',{staticClass:"tw-h-3 tw-bg-gradient-to-b tw-from-blue-100/100 tw-to-blue-100/0"}):_vm._e()],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }